import React from "react"
import ReactDOM from "react-dom"
import PartnerShowcaseComponent from "./partner-showcase-component"

export default class PartnerShowcaseModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<PartnerShowcaseComponent {...this.modelJson} />, self.elem)
  }
}
